import { render } from "./Quotation.vue?vue&type=template&id=436b2baa"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"
script.render = render

export default script